import { useState } from 'react';

import e_angencard from '../assets/payments/e_angencard.png';
import e_bna from '../assets/payments/e_bna.png';
import e_cabal from '../assets/payments/e_cabal.png';
import e_cabaldebito from '../assets/payments/e_cabaldebito.png';
import e_cbu from '../assets/payments/e_cbu.png';
import e_debin from '../assets/payments/e_debin.png';
import e_epagos from '../assets/payments/e_epagos.png';
import e_link from '../assets/payments/e_link.png';
import e_modo from '../assets/payments/e_modo.png';
import e_mp from '../assets/payments/e_mp.png';
import e_pagofacil from '../assets/payments/e_pagofacil.png';
import e_pagomiscuentas from '../assets/payments/e_pagomiscuentas.png';
import e_rapipago from '../assets/payments/e_rapipago.png';
import e_santander from '../assets/payments/e_santander.png';
import visaDebito from '../assets/payments/logo-visa-debito.png';
import visa from '../assets/payments/logo-visa.png';
import amExpress from '../assets/payments/logo-american-express.png';
import mastercard from '../assets/payments/logo-mastercard.png';

export default function PaymentSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 6;

  const paymentMethods = [
    visa,
    visaDebito,
    amExpress,
    mastercard,
    e_angencard,
    e_bna,
    e_cabal,
    e_cabaldebito,
    e_cbu,
    e_debin,
    e_epagos,
    e_link,
    e_modo,
    e_mp,
    // e_pagofacil,
    // e_pagomiscuentas,
    // e_rapipago,
    e_santander,
  ];

  const nextSlide = () => {
    if (currentIndex + itemsPerPage < paymentMethods.length) {
      setCurrentIndex(currentIndex + itemsPerPage);
    } else {
      setCurrentIndex(0);
    }
  };

  const prevSlide = () => {
    if (currentIndex - itemsPerPage >= 0) {
      setCurrentIndex(currentIndex - itemsPerPage);
    } else {
      setCurrentIndex(paymentMethods.length - itemsPerPage);
    }
  };

  return (
    <div className="payment-slider" style={{
      display: 'flex',
      justifyContent: 'between',
      // marginTop: 10,
      marginBottom: 10
    }}>
      <button className="prev" style={{
        border: 'none',
        background: 'white',
        color: 'gray',
        fontSize: 20,
        marginBottom: 10,
        cursor: 'pointer'
      }} onClick={prevSlide}>❮</button>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: 10,
        alignItems: 'center',
        width: '100%'
      }}>
        {paymentMethods.slice(currentIndex, currentIndex + itemsPerPage).map((image, index) => (
          <div className="slider-item" key={index}>
            <img src={image} alt={`Método de pago ${index}`} className="slider" style={{
              width: '40px',
              height: 'fit-content'
            }} />
          </div>
        ))}
      </div>

      <button className="next" style={{
        border: 'none',
        background: 'white',
        color: 'gray',
        fontSize: 20,
        marginBottom: 10,
        cursor: 'pointer'
      }} onClick={nextSlide}>❯</button>
    </div>
  );
}
